export default __webpack_public_path__ + "static/developers-logo-d20318a881729d371a7ba23b12d09f43.svg";